import React from 'react';
import { Controller } from 'react-hook-form';
import { Stack, TextField } from '@mui/material';
import { FormControlLabel, Switch } from '@material-ui/core';

import { H4 } from 'components/Typography';
import { controlledFileUpload } from 'components/ReactHookForm/controlledFileUpload';
import { imageTypes } from 'retired/FileUpload/utils';
import FormDescriptionRteField from 'retired/FormDescriptionRteField';
import { maxLengthRichText } from 'utils/validators';

import type { FormFieldValues } from '../formType';

const InputBannerImage = controlledFileUpload<FormFieldValues>()('headerImage');
const InputTileImage = controlledFileUpload<FormFieldValues>()('tileImage');

interface TitleDescriptionImageProps {
  entityType?: 'team' | 'community';
}

export const TitleDescriptionImage = ({
  entityType = 'community',
}: TitleDescriptionImageProps): JSX.Element => {
  const isTeam = entityType === 'team';
  const entityName = isTeam ? 'Team' : 'Community';

  return (
    <Stack spacing={3}>
      <Controller
        name="enabled"
        render={({ field }): JSX.Element => (
          <FormControlLabel
            control={
              <Switch
                checked={field.value || false}
                color="primary"
                onChange={(_, checked) => field.onChange(checked)}
                name="enabled"
              />
            }
            label={field.value ? 'Active' : 'Inactive'}
            style={{ width: 120, marginTop: 25 }}
          />
        )}
      />
      <H4>About us</H4>
      <Controller
        name="title"
        render={({ field: { ref, ...field }, fieldState }): JSX.Element => (
          <TextField
            label={`${entityName} Name`}
            helperText={fieldState.error?.message || 'Max 65 characters'}
            inputRef={ref}
            required
            error={!!fieldState.error}
            {...field}
          />
        )}
        rules={{
          maxLength: { value: 65, message: 'Max 65 characters' },
          required: `${entityName} name is required`,
        }}
      />
      <Controller
        name="description"
        render={({ field: { ref, ...field }, fieldState }): JSX.Element => (
          <FormDescriptionRteField
            label={`${isTeam ? 'Team Description' : 'Write about your community here'} *`}
            input={field}
            helperText="Max 2000 characters"
            meta={{
              touched: fieldState.isTouched || fieldState.isDirty,
              error: fieldState.error?.message,
            }}
            height={200}
          />
        )}
        rules={{
          validate: maxLengthRichText(2000),
          required: 'Description is required',
        }}
      />
      <H4>Background for the Header</H4>
      <InputTileImage
        acceptedTypes={imageTypes}
        label={`${entityName} Image (1920x1080)`}
        imagePreview
      />
      <InputBannerImage
        acceptedTypes={imageTypes}
        label={`${entityName} Banner (1920x480)`}
        imagePreview
      />
    </Stack>
  );
};
